import React from 'react';
import { Container } from '../ui/Container';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { Check, ArrowRight } from 'lucide-react';
export function MoneyPageSpotlight() {
  return <Section className="bg-white" id="services-spotlight" data-id="element-303">
      <Container data-id="element-304">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-305">
          {/* Business Cards Block */}
          <div id="business-cards" className="bg-gradient-to-br from-cyan-50 to-white rounded-3xl overflow-hidden shadow-lg border border-cyan-100 flex flex-col relative group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1" data-id="element-306">
            {/* Badge */}
            <div className="absolute top-4 right-4 bg-magenta-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md z-10" data-id="element-307">
              MOST POPULAR
            </div>

            <div className="h-64 relative overflow-hidden" data-id="element-308">
              {/* Placeholder for Business Card Image with Gradient Overlay */}
              <div className="absolute inset-0 bg-gray-200" data-id="element-309">
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-900/80 to-blue-900/80 flex flex-col items-center justify-center text-white p-6 text-center" data-id="element-310">
                  <span className="text-5xl font-black tracking-tighter opacity-20 mb-2" data-id="element-311">
                    CARDS
                  </span>
                  <p className="font-medium opacity-80" data-id="element-312">
                    Premium Quality • Fast Turnaround
                  </p>
                </div>
              </div>

              {/* Mascot Overlay */}
              <img src="https://cdn.magicpatterns.com/uploads/oRjVdEwcjrJByMjpUoNSga/cute-colour-inkling.png" alt="Mascot with cards" className="absolute -bottom-8 -right-8 w-32 h-auto drop-shadow-lg transform rotate-12 group-hover:scale-110 transition-transform duration-500" data-id="element-313" />
            </div>

            <div className="p-8 flex-1 flex flex-col relative" data-id="element-314">
              <h3 className="text-2xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-315">
                Business Cards
                <span className="ml-3 text-sm font-normal text-cyan-600 bg-cyan-50 px-2 py-0.5 rounded-md border border-cyan-100" data-id="element-316">
                  From $49
                </span>
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-317">
                Premium quality cards that make an impression. Multiple
                finishes, stocks, and sizes available to match your brand.
              </p>
              <ul className="space-y-3 mb-8 flex-1" data-id="element-318">
                {['Matt, Gloss & Velvet laminates', 'Spot UV & Foiling options', 'Rounded corners available', 'Fast turnaround guaranteed'].map(feature => <li key={feature} className="flex items-start text-sm text-gray-700" data-id="element-319">
                    <div className="mt-0.5 mr-3 p-0.5 rounded-full bg-cyan-100 text-cyan-600" data-id="element-320">
                      <Check className="h-3 w-3" data-id="element-321" />
                    </div>
                    {feature}
                  </li>)}
              </ul>
              <Button fullWidth className="bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 border-0 shadow-md" onClick={() => document.getElementById('quote')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-322">
                Get a Business Card Quote
                <ArrowRight className="ml-2 h-4 w-4" data-id="element-323" />
              </Button>
            </div>
          </div>

          {/* Signage Block */}
          <div id="signage" className="bg-gradient-to-br from-magenta-50 to-white rounded-3xl overflow-hidden shadow-lg border border-magenta-100 flex flex-col relative group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1" data-id="element-324">
            {/* Badge */}
            <div className="absolute top-4 right-4 bg-cyan-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md z-10" data-id="element-325">
              FULL SERVICE
            </div>

            <div className="h-64 relative overflow-hidden" data-id="element-326">
              {/* Placeholder for Signage Image */}
              <div className="absolute inset-0 bg-gray-200" data-id="element-327">
                <div className="absolute inset-0 bg-gradient-to-br from-magenta-900/80 to-purple-900/80 flex flex-col items-center justify-center text-white p-6 text-center" data-id="element-328">
                  <span className="text-5xl font-black tracking-tighter opacity-20 mb-2" data-id="element-329">
                    SIGNS
                  </span>
                  <p className="font-medium opacity-80" data-id="element-330">
                    Design • Print • Install
                  </p>
                </div>
              </div>

              {/* Mascot Overlay */}
              <img src="https://cdn.magicpatterns.com/uploads/oRjVdEwcjrJByMjpUoNSga/cute-colour-inkling.png" alt="Mascot worker" className="absolute -bottom-8 -left-4 w-32 h-auto drop-shadow-lg transform -rotate-12 scale-x-[-1] group-hover:scale-x-[-1.1] group-hover:scale-y-[1.1] transition-transform duration-500" data-id="element-331" />
            </div>

            <div className="p-8 flex-1 flex flex-col" data-id="element-332">
              <h3 className="text-2xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-333">
                Signage + Installation
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-334">
                From design to installation — complete signage solutions for
                your business. We handle the entire process.
              </p>
              <ul className="space-y-3 mb-8 flex-1" data-id="element-335">
                {['Shop fronts & Window graphics', 'A-frames & Banners', 'Vehicle signage & Wraps', 'Professional installation team'].map(feature => <li key={feature} className="flex items-start text-sm text-gray-700" data-id="element-336">
                    <div className="mt-0.5 mr-3 p-0.5 rounded-full bg-magenta-100 text-magenta-600" data-id="element-337">
                      <Check className="h-3 w-3" data-id="element-338" />
                    </div>
                    {feature}
                  </li>)}
              </ul>
              <Button fullWidth className="bg-gradient-to-r from-magenta-500 to-purple-500 hover:from-magenta-600 hover:to-purple-600 border-0 shadow-md" onClick={() => document.getElementById('quote')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-339">
                Get a Signage Quote
                <ArrowRight className="ml-2 h-4 w-4" data-id="element-340" />
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </Section>;
}